import React from 'react';
import { ELEMENT_TYPES } from '../../services/branding';

import './preview.less';

export default class Preview extends React.Component {
    render() {
        const { elementName = '', styles, ...props } = this.props;

        switch ( elementName.toUpperCase() ) {
            case ELEMENT_TYPES.BUTTON:
                return this.renderPreviewElement( styles, this.getButtonHtml(), props );
            case ELEMENT_TYPES.LINK:
                return this.renderPreviewElement( styles, this.getLinkHtml(), props );
            default:
                return null;
        }
    }

    renderPreviewElement = ( styles, html, props ) => {
        if ( !Array.isArray( styles ) ) {
            return {};
        }

        styles.forEach( style => {
            html = html
                .replace( `{{${ style.propertyName }}}`, style.value )
                .replace( `{{ ${ style.propertyName } }}`, style.value );
        } );

        return (
            <div
                { ...props }
                className="branding-preview-element-host"
                dangerouslySetInnerHTML={ { __html: html } }
            />
        );
    };

    getButtonHtml = () => {
       return `
            <style>
                #previewElement {
                    color: {{color}};
                    background-color: {{background-color}};
                    border-color: {{border-color}};
                    border-style: {{border-style}};
                    border-width: {{border-width}}px;
                    border-radius: {{border-radius}}px;
                    padding: 4px 15px;
                }
            </style>
            <button id="previewElement">
                Sample Button
            </button>
        `;
    };
    getLinkHtml = () => {
        return `
             <style>
                 #previewElement {
                     color: {{color}};
                 }
             </style>
             <a href="example" id="previewElement">
                 Sample Link
             </button>
         `;
    };
}
